import React from 'react'
import {Col} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'


const ProfileCard = ({ profile }) => {
    return (
        <>
            <Col lg={3} className='profileCard'>
                <img className='profileCard-img' src={profile.image} alt='' />
                <div className='profileCard-name'><a rel="noreferrer" target={'_blank'} href={profile.url}>{profile.name}</a></div>
                <div className='profileCard-post'>{profile.title}&nbsp;</div>
                <div className='profileCard-info'>{profile.company}&nbsp;</div>

                {profile.url ?
                    <div className='profileCard-url'> <a rel={'noreferrer'} target={'_blank'} href={profile.url}><FontAwesomeIcon icon={faLinkedin} /></a></div> : ''
                }
            </Col>
        </>
    )
}

export default ProfileCard
